import React, {useState, useEffect} from 'react';
import './Css/Registration.css';
import CompanyInfoChip from "../Components/CompanyInfoChip";
import Swal from "sweetalert2";
import icon_search from "../Image/icon_search.png"; // 스타일링을 위한 CSS 파일
import Tabs from "../Components/Tabs";
import Registration_body1 from "../Components/Registration_body1";
import Registration_body2 from "../Components/registration_body2";
import axios from "axios";
import config from "../ip.json";

const Registration = () => {
    const [companyName, setCompanyName] = useState('');
    const [representative, setRepresentative] = useState('');
    const [moveInDate, setMoveInDate] = useState('');
    const [contractEndDate, setContractEndDate] = useState('');
    const [selectedRoom, setSelectedRoom] = useState('업체 등록');  // 선택된 방 저장 상태
    const [isTransitioning, setIsTransitioning] = useState(false); // 상태 전환 중인지 여부
    const [testArr, setTestArr] = useState([]); // 모달의 상태를 관리
    const companyNames = testArr.map(item => item);
    const [loding, setLoding] = useState(true); // 로딩 상태
    const [searchValue, setSearchValue] = useState(""); // 검색어 상태



    const [name, setName] = useState('');

    useEffect(() => {

        setLoding(true)

        fetchData(); // 비동기 함수 호출
    }, []); // 빈 배열로 의존성 없음
    const fetchData = async () => {
        try {
            const response = await axios.get(config.url + "/v2/company/all", {
                headers: {
                    "Content-Type": "application/json",
                },
                withCredentials: true, // 쿠키 필요 시 설정
            });
            console.log(response.data); // 콘솔로 데이터 확인
            console.log(config.url)
            setTestArr(response.data)
            setLoding(false)

        } catch (error) {
            console.error("Error fetching data:", error);
            alert("데이터를 가져오는 중 문제가 발생했습니다.");
        }
    };
    const 업체등록성공 = (companyName, representative) => {
        Swal.fire({
            title: "업체가 등록되었습니다!",
            text: "업체명 : " + companyName + ", 대표자명 : " + representative,
            icon: "success"
        });
    }

    const 업체등록실패 = (companyName, representative) => {
        Swal.fire({
            title: "업체가 등록되었습니다!",
            text: "업체명 : " + companyName + ", 대표자명 : " + representative,
            icon: "error"
        });
    }

    const handleSubmit = (e) => {
        업체등록성공(companyName, representative)
        e.preventDefault();
        console.log('업체 등록:', {companyName, representative, moveInDate, contractEndDate});
    };

    const handleChipClick = (name) => {
        setName(name)
    };

    const handleTabSelect = (tabName) => {
        setIsTransitioning(true); // 전환 애니메이션 시작
        setTimeout(() => {
            setSelectedRoom(tabName);  // 선택된 탭 상태 업데이트
            setIsTransitioning(false); // 전환 애니메이션 끝
        }, 200); // 애니메이션 시간에 맞춰 상태를 업데이트
    };
    const filteredCompanies = companyNames.filter((item) =>
        item.company.toLowerCase().includes(searchValue.toLowerCase()) // 대소문자 구분 없음
    );
    const handleSearchChange = (event) => {
        setSearchValue(event.target.value); // 검색어 업데이트
    };
    return (
        <div className="registration-container">

            <div className={'registration-middle-container'}>

                <div className={'registration-sidebar'}>
                    <div className="search">
                        <img className="icon_search" src={icon_search} alt="See more"/>
                        <input
                            className="search-bar"
                            placeholder="업체명을 입력하세요"
                            value={searchValue} // 입력값과 상태 연동
                            onChange={handleSearchChange} // 검색어 입력 시 업데이트
                        />
                    </div>

                    {loding ? (
                        <div className="sidebar-loader"></div> // 로딩 스피너 출력
                    ) : (
                        filteredCompanies.map((item) => (
                            <CompanyInfoChip
                                key={item.id}
                                name={item.company}
                                roomCount={item.roomCount}
                                onClick={handleChipClick} // ID 전달
                            />
                        ))
                    )}
                </div>
                <div className={'registration-mainbox'}>
                    <div className={'registration-title-box'}>

                        <div className={'registration-title'}>등록</div>
                        <div className={'registration-subtitle'}>신규 입주한 업체를 등록하고 각 업체별 호실을 관리하세요.</div>
                        <div className={'registration-inner-container'}>
                            <div className={'registration-inner-container-topbar'}>
                                <div className={'Tabs-box'}>
                                    <Tabs rooms={['업체 등록', '입주 호실 추가']} onTabSelect={handleTabSelect}/>
                                </div>
                            </div>

                            <div className={`fade-in ${isTransitioning ? '' : 'show'}`}>
                                {selectedRoom === '업체 등록' && <Registration_body1/>}
                                {selectedRoom === '입주 호실 추가' && <Registration_body2 companyList={companyNames}/>}
                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </div>
    );
};

export default Registration;
